<template>
    <div>
        <card class="card-default mt-4">
            <card-header class="d-flex">
                <b>{{ campaign.id }} - {{ campaign.name }}</b> <span class="id align-self-center">(id:{{ campaign.id }})</span>
                <div class="ml-auto">
                    <button class="btn btn-default btn-sm btn-icon ml-1" title="Duplicate" @click="replicate(campaign.id)">
                        <i class="fa fa-fw fa-copy"></i>
                    </button>
                    <button class="btn btn-default btn-sm btn-icon ml-1" title="Delete" @click="remove">
                        <i class="fa fa-fw fa-trash"></i>
                    </button>
                    <a class="btn btn-default btn-sm btn-icon ml-1"
                        :href="$laroute.route('campaigns.cx.edit', { cx: campaign.id })" title="Edit">
                        <i class="fa fa-fw fa-pencil-alt"></i>
                    </a>
                </div>
            </card-header>
            <card-body class="pt-0">
                <div class="form-row">
                    <div class="col-md-3">
                        <img class="mw-100 mb-2 rounded" :src="image_url" />
                        <button class="btn btn-default btn-block" @click="openSmsPreview(campaign)">
                            Preview SMS<i class="fas fa-comment-alt ml-2"></i>
                        </button>
                        <button class="btn btn-default btn-block" @click="openEmailPreview(campaign)">
                            Preview Email<i class="fas fa-envelope ml-2"></i>
                        </button>
                    </div>
                    <div class="col-md-9">
                        <campaign-metrics
                            :data="campaign.metrics_campaign"
                            :expanded.sync="expand"
                            :hide-review-sites="true"
                        />
                    </div>
                </div>
                <transition name="fade">
                    <div class="form-row mt-3" ref="details" v-if="expand">
                        <div class="col-md-3">
                            <div class="panel">
                                <div class="panel-header">Locations</div>
                                <div class="panel-body p-0" style="max-height: 200px; overflow-y: auto;">
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item" v-for="location of campaign.locations" :key="location.id">
                                            <i class="fa fa-map-marker-alt mr-2"></i>
                                            {{ location.name }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-9">
                            <div class="form-row mb-3">
                                <div class="col">
                                    <div class="panel" style="min-height: 240px;">
                                        <div class="panel-header">Response Metrics</div>
                                        <div class="panel-body">
                                            <rating-metrics :data="campaign.metrics_rating"></rating-metrics>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </card-body>
        </card>
    </div>
</template>

<script>
    import RatingMetrics from '../metrics/RatingMetrics';
    import CampaignMetrics from './CampaignMetrics';

    export default {
        components: {RatingMetrics, CampaignMetrics},

        props: ['campaign'],

        data() {
            return {
                expand     : false,
                options    : {
                    type             : 'warning',
                    title            : 'Make a copy?',
                    text             : 'You wanna make a copy of this campaign?',
                    confirmButtonText: 'Make a copy',
                    closeOnConfirm   : true
                },
                previewData: null,
                message    : null
            }
        },

        computed: {
            image_url() {
                return this.campaign.image_url || '/img/image.jpg';
            },
        },

        mounted() {
            $(this.$refs.details).hide();
        },

        methods: {
            toggle() {
                const details = $(this.$refs.details);
                this.expand ? this.showDetails() : this.hideDetails();
            },

            hideDetails() {
                $(this.$refs.details).animate({
                    opacity: 0,
                    height : 'hide',
                }, 200);
            },
            showDetails() {
                $(this.$refs.details).animate({
                    opacity: 1,
                    height : 'show',
                }, 200);
            },

            remove() {
                this.$confirm().then(() => {
                    this.$http.delete(this.$laroute.route('api.cx-campaigns.destroy', {cx_campaign: this.campaign.id}))
                        .then(res => {
                            const message = res.data.message;
                            this.$alert({message, type: 'success', title: 'Success!'});
                            this.$emit('deleted');
                        })
                        .catch(err => console.log('err from delete', err))
                });
            },

            replicate(id) {
                this.$confirm(this.options).then(() => {
                    this.$http.post(this.$laroute.route('api.campaigns.replicate', {campaign: id}))
                        .then(({data}) => this.$emit('replicated'))
                });
            },

            openSmsPreview(campaign) {
                this.$parent.openSmsPreview(campaign);
            },

            openEmailPreview(campaign) {
                this.$parent.openEmailPreview(campaign);
            }
        }
    }
</script>

<style scoped>
    .id {
        font-size: 0.8em;
        padding-left: 5px;
        color: #B2B2B2;
    }
</style>
